import CloseIcon from '@mui/icons-material/Close';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import {Box, IconButton, Typography} from '@mui/material';

import {profileComparisonTrayEmptySx, profileComparisonTraySlotSx} from './profileComparisonSectionStyles';
import type {CompanyWorkforceProfile} from '../../types/WorkforceProfileTypes';
import {getWorkforceProfileDisplayId} from '../../utils/WorkforceProfiles/getWorkforceProfileDisplayId';

export interface Props {
  label: string;
  profile: CompanyWorkforceProfile | null;
  colors: {borderColor: string; color: string; bgcolor: string};
  onDeselect: () => void;
}

export const ProfileComparisonSelectionTraySlot = ({label, profile, colors, onDeselect}: Props) => {
  const score = profile?.alignment?.overall;

  if (!profile) {
    return (
      <Box sx={profileComparisonTrayEmptySx}>
        <RadioButtonUncheckedIcon sx={{fontSize: 13, opacity: 0.6}} />
        {label}
      </Box>
    );
  }

  return (
    <Box
      sx={{
        ...profileComparisonTraySlotSx,
        border: '1.5px solid',
        borderColor: colors.borderColor,
        color: colors.color,
        bgcolor: colors.bgcolor,
        cursor: 'pointer',
      }}
    >
      <PersonOutlineIcon sx={{fontSize: 13}} />
      <Typography component='span' sx={{fontSize: '12.5px', fontWeight: 500}}>
        {getWorkforceProfileDisplayId(profile)}
      </Typography>
      {score != null && (
        <Typography component='span' sx={{fontSize: '11px', opacity: 0.6}}>
          · {score}%
        </Typography>
      )}
      <IconButton
        size='small'
        onClick={(event) => {
          event.stopPropagation();
          onDeselect();
        }}
        aria-label={`Deselect ${label}`}
        sx={{ml: 'auto', p: 0, color: 'inherit', opacity: 0.6}}
      >
        <CloseIcon sx={{fontSize: 12}} />
      </IconButton>
    </Box>
  );
};
